// +----------------------------------------------------------------------
// | Desc:导入全局配置
// +----------------------------------------------------------------------
import Vue from "vue";



// +----------------------------------------------------------------------
// | 导出Excel
// +----------------------------------------------------------------------
Vue.prototype.$QHexcelDownload = function (that, scene, showPrice, fileName) {
  //排放单位CDNEXCEL下载库配置
  const Config = {
    kind: {
      100: "发明专利",
      200: "实用新型",
      300: "外观设计",
    },
    type: {
      100: "未下证",
      200: "已下证",
      300: "未标记",
      0: "未标记",
    },
    status: {
      100: "可预订",
      200: "被预订",
      300: "仅排队",
      400: "已售出",
      500: "已下架",
    },
  };
  const tableHeaders = [
    { title: "专利类型", key: "kind", fmtType: "Config", fmtValue: "kind" },
    { title: "下证状态", key: "type", fmtType: "Config", fmtValue: "type" },
    { title: "专利编号", key: "applicationNumber",width: 17.5},
    { title: "专利名称", key: "title", align: "left" },
    { title: "专利价格", key: "price", fmtType: "unit" },
    { title: "官费时间", key: "expenseTime", width: 17.5, fmtType: "date", fmtValue: "YYYY-MM-DD" },
    { title: "可否预定", key: "status", fmtType: "Config", fmtValue: "status" },
  ];

  //查询条件
  that.searchMap = that.$trimObjectSpaces(that.searchMap);
  var searchMap = that.$copyObj(that.searchMap);
  searchMap["ids"] = that.$copyObj(that.selectedRows);
  searchMap["scene"] = scene;

  //查询数据
  that.$refs.QHexcelDownload.hiPop({
    title: fileName,
    showPrice: showPrice,
    Config: Config,
    api: this.$api.getCGYXZhuanliExcelList,
    searchMap: searchMap,
    columns: tableHeaders,
  });
};
